// Price editing functionality for Order#show
document.addEventListener('DOMContentLoaded', function() {
  // Wait for other scripts to load
  setTimeout(function() {
    const priceInput = document.querySelector('.price-input-field');
    const saveBtn = document.querySelector('.save-price-btn');
    const cancelBtn = document.querySelector('.cancel-price-btn');
    
    if (!priceInput || !saveBtn || !cancelBtn) {
      return; // Elements not found, probably not on the right page
    }
    
    let originalValue = priceInput.value;
    
    // Check for changes and enable/disable save button
    function checkForChanges() {
      const currentValue = priceInput.value;
      const hasChanged = currentValue !== originalValue;
      
      if (hasChanged) {
        saveBtn.disabled = false;
        saveBtn.style.opacity = '1';
        saveBtn.style.cursor = 'pointer';
        saveBtn.classList.remove('disabled');
      } else {
        saveBtn.disabled = true;
        saveBtn.style.opacity = '0.5';
        saveBtn.style.cursor = 'not-allowed';
        saveBtn.classList.add('disabled');
      }
    }
    
    // Initial check
    checkForChanges();
    
    // Event listeners for input changes
    ['input', 'change', 'keyup'].forEach(eventType => {
      priceInput.addEventListener(eventType, checkForChanges);
    });
    
    // Save button click handler
    saveBtn.addEventListener('click', function(e) {
      e.preventDefault();
      
      if (!this.disabled) {
        savePrice();
      }
    });
    
    // Cancel button click handler
    cancelBtn.addEventListener('click', function(e) {
      e.preventDefault();
      priceInput.value = originalValue;
      checkForChanges();
    });
    
    // Keyboard shortcuts
    priceInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && !saveBtn.disabled) {
        e.preventDefault();
        savePrice();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        priceInput.value = originalValue;
        checkForChanges();
      }
    });
    
    // Save function
    function savePrice() {
      const newPrice = priceInput.value;
      const orderId = priceInput.dataset.orderId;
      
      // Show loading state
      const originalButtonContent = saveBtn.innerHTML;
      saveBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i><span class="ml-2">Saving...</span>';
      saveBtn.disabled = true;
      priceInput.disabled = true;
      
      // Prepare form data
      const formData = new FormData();
      formData.append('id', orderId);
      formData.append('price', newPrice);
      
      // Send to server
      fetch('/outp', {
        method: 'POST',
        body: formData,
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
      })
      .then(response => response.json())
      .then(data => {
        if (data.isOk || data.success || data.result || data.key === 'OrderUpdatedOk') {
          originalValue = newPrice;
          showSuccess('Price updated successfully! Reloading page...');
          
          // Update the displayed price if there's a price display element
          const priceDisplay = document.querySelector('.price-display');
          if (priceDisplay) {
            priceDisplay.textContent = `$${parseFloat(newPrice).toLocaleString()}`;
          }
          
          // Reload the page after a short delay to show the success message
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          showError('Error updating price: ' + (data.error || data.notice || 'Unknown error'));
        }
      })
      .catch(error => {
        showError('Error updating price: ' + error.message);
      })
      .finally(() => {
        // Restore button state
        saveBtn.innerHTML = originalButtonContent;
        priceInput.disabled = false;
        checkForChanges();
      });
    }
    
    // Show success message
    function showSuccess(message) {
      showMessage(message, 'success');
    }
    
    // Show error message
    function showError(message) {
      showMessage(message, 'danger');
    }
    
    // Show message helper
    function showMessage(message, type) {
      const alertDiv = document.createElement('div');
      alertDiv.className = `alert alert-${type} mt-2`;
      alertDiv.textContent = message;
      
      // Insert after the button group
      const buttonGroup = document.querySelector('.button-group');
      if (buttonGroup && buttonGroup.parentNode) {
        buttonGroup.parentNode.insertBefore(alertDiv, buttonGroup.nextSibling);
        
        // Remove after 4 seconds
        setTimeout(() => {
          if (alertDiv.parentNode) {
            alertDiv.parentNode.removeChild(alertDiv);
          }
        }, 4000);
      }
    }
    
  }, 500);
});
